import React from "react";
import { Container, Row, Col } from "react-bootstrap";
// import Link from "next/link";
import { Link, useLocation } from "react-router-dom";
import  logo from "../../assets/logo-svg.png";
import styles from "./Contactus.module.css";
import { BsWhatsapp } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";
import { FaSquareInstagram } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa6";
import { useSelector } from "react-redux";
export default function Contactus() {
  const location = useLocation();
  const asPath=location?.pathname;
  
  const { currentLocal } = useSelector((state) => state.currentLocal);

  return (
    <div className={styles.contactus}>
      <Container fluid>
        <Row>
          <Col md={4}>
            <Link to="/">
              <img
                src={logo}
                alt="logo"
                style={{ width: "200px", cursor: "poiter" }}
              />
            </Link>{" "}
            <div className={currentLocal?.language=="العربيه"?styles.arAboutParag:styles.enAboutParag}>{currentLocal.general.aboutParag}</div>
          </Col>
          <Col md={4}>
            <h3 className={styles.quickLinks}>quickLinks</h3>
            <ul className={styles.navItem}>
              <li>
                {" "}
                <Link to="/">{currentLocal.general.home}</Link>
              </li>
              <li>
                {" "}
                <Link to="/aboutus">{currentLocal.general.about}</Link>
              </li>
              <li>
                {" "}
                <Link to="/services">{currentLocal.general.services}</Link>
              </li>
              <li>
                {" "}
                <Link to="/contact-us">{currentLocal.general.contact}</Link>
              </li>
            </ul>
          </Col>
          <Col md={4}>
          <h3 className={styles.quickLinks}>{currentLocal.general.quickLinks}</h3>
            <div className={styles.socialMedia}>
              <a href="https://wa.me/+201000943383">
                {" "}
                <div className={styles.whatsapp}>
                  <BsWhatsapp className={styles.BsWhatsapp} />
                </div>
              </a>
              <a href="https://www.facebook.com/Nanosoft.programming">
                {" "}
                <div className={styles.whatsapp}>
                  <FaFacebookF className={styles.BsWhatsapp} />
                </div>
              </a>
              <a href="https://www.instagram.com/nanosoft.programming/">
                {" "}
                <div className={styles.whatsapp}>
                  <FaSquareInstagram className={styles.BsWhatsapp} />
                </div>
              </a>
              <a href="https://www.linkedin.com/in/nanosoft-programming-2b0935389/">
                {" "}
                <div className={styles.linkedin}>
                  <FaLinkedin className={styles.FaLinkedin} />
                </div>
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
